export const columns = [
  {
    Header: "Entidad",
    accessor: "name",
    filterable: true,
    filterMethod: (filter, row) => row.name.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: "Cantidad de Cambios",
    accessor: "changesCount",
    filterable: true,
    filterMethod: (filter, row) => row.changesCount.toLowerCase().includes(filter.value.toLowerCase())
  }
];